import type { CatalogResource } from '../../types.js';
import { companyManagement } from './company-management.js';
import { network } from './network.js';
import { products } from './products.js';
import { reports } from './reports.js';
import { riskManagement } from './risk-management.js';
import { traceability } from './traceability.js';
import { vendorCompliance } from './vendor-compliance.js';

/** All resource types, grouped by feature group (one file per group). */
export const RESOURCES = [
  ...network,
  ...products,
  ...vendorCompliance,
  ...traceability,
  ...riskManagement,
  ...reports,
  ...companyManagement,
] as const satisfies readonly CatalogResource[];
